import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-system-down',
  templateUrl: './system-down.component.html',
  styleUrls: ['./system-down.component.scss']
})
export class SystemDownComponent implements OnInit {

  constructor(private _router:Router, private ngZone: NgZone) { }

  ngOnInit(): void {
  }

  gotoWelcome(){
    this.ngZone.run(() => {
      this._router.navigate(['welcome', 'appnavigator']);
      });
    
  }

}
